export function getChargeRows(source) {
  if (Array.isArray(source?.items) && source.items.length === 0) return [];

  return (source?.chargesBreakdown ?? []).map((charge, index) => ({
    id: charge.charge_id || charge.slug || charge.name || `charge-${index}`,
    label: charge.name || charge.slug || 'Charges',
    amount: Number(charge.charge_amount ?? 0),
  }));
}
